import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import {
  ApiBaseError,
  AppleGooglePay,
  Booking,
  BookingRegister,
  DataList,
  RegisterBookingResponse,
} from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class BookingService {
  constructor(private apiService: ApiService) {}

  register(bookingData: BookingRegister): Observable<RegisterBookingResponse> {
    return this.apiService.post<RegisterBookingResponse>(`user/bookings`, bookingData).pipe();
  }

  appleGooglePay(booking: AppleGooglePay): Observable<RegisterBookingResponse> {
    console.log('sending:', booking);
    return this.apiService.post<RegisterBookingResponse>(`user/bookings/payment`, booking).pipe();
  }

  listNext(length: number = 25): Observable<DataList<Booking>> {
    return this.apiService.get<DataList<Booking>>(`user/bookings/next?length=${length}`).pipe();
  }

  listPrevious(length: number = 25): Observable<DataList<Booking>> {
    return this.apiService.get<DataList<Booking>>(`user/bookings?length=${length}`).pipe();
  }

  get(id: number): Observable<Booking> {
    return this.apiService.get<Booking>(`user/bookings/${id}`).pipe();
  }

  cancel(id: number): Observable<ApiBaseError> {
    return this.apiService.delete<ApiBaseError>(`user/bookings/${id}`).pipe();
  }

  saveCheckOut(id: number, check_in: string): Observable<RegisterBookingResponse> {
    return this.apiService.put<RegisterBookingResponse>(`frontdesk/bookings`, { id: id, check_in: check_in }).pipe();
  }

  saveCheckIn(id: number, check_in: string): Observable<RegisterBookingResponse> {
    return this.apiService.post<RegisterBookingResponse>(`frontdesk/bookings`, { id: id, check_in: check_in }).pipe();
  }

  listFontDesk(date: string, length: number = 25): Observable<DataList<Booking>> {
    return this.apiService.get<DataList<Booking>>(`frontdesk/bookings?length=${length}&date=${date}`).pipe();
  }
}
